module.exports = __webpack_public_path__ + "img/amazon.0a17ea12.png";